<template>
  <div class="flex" :style="{ alignItems: align, justifyContent: justify, direction }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Flex',

  props: {
    align: {
      type: String,
      default: 'center'
    },

    justify: {
      type: String,
      default: 'flex-start'
    },

    direction: {
      type: String,
      default: 'row'
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.flex
  display: flex
  position: relative

.container
  > .flex:not(.flex-item)
    margin-top: $margin * 2
    margin-bottom: $margin * 2
</style>
